export default class RouterConstants {
	public static readonly CONSOLE = {
		path: "/console",
		fullPath: "/console",
	};

	public static readonly IMAGE_GENERATION = {
		path: "image-generation",
		fullPath: `${this.CONSOLE.path}/image-generation`,

		OVERVIEW: {
			path: "overview",
			fullPath: `${this.CONSOLE.path}/image-generation/overview`,
		},

		API: {
			path: "api",
			fullPath: `${this.CONSOLE.path}/image-generation/api`,
		},

		IFRAME: {
			path: "iframe",
			fullPath: `${this.CONSOLE.path}/image-generation/iframe`,
		},

		COMFYUI: {
			path: "comfy-ui",
			fullPath: `${this.CONSOLE.path}/image-generation/comfy-ui`,
		},

		DEMO: {
			path: "demo",
			fullPath: `${this.CONSOLE.path}/image-generation/demo`,

			IMAGE_GENERATION: {
				path: "image-generation",
				fullPath: `${this.CONSOLE.path}/image-generation/demo/image-generation`,
			},

			TEXT_TO_VECTOR: {
				path: "text-to-vector",
				fullPath: `${this.CONSOLE.path}/image-generation/demo/text-to-vector`,
			},
		},
	};

	public static readonly IMAGE_EDITING = {
		path: "image-editing",
		fullPath: `${this.CONSOLE.path}/image-editing`,

		OVERVIEW: {
			path: "overview",
			fullPath: `${this.CONSOLE.path}/image-editing/overview`,
		},

		API: {
			path: "api",
			fullPath: `${this.CONSOLE.path}/image-editing/api`,
		},

		IFRAME: {
			path: "iframe",
			fullPath: `${this.CONSOLE.path}/image-editing/iframe`,
		},

		COMFYUI: {
			path: "comfy-ui",
			fullPath: `${this.CONSOLE.path}/image-editing/comfy-ui`,
		},

		DEMO: {
			path: "demo",
			fullPath: `${this.CONSOLE.path}/image-editing/demo`,
			IMAGE_EDITING: {
				path: "image-editing",
				fullPath: `${this.CONSOLE.path}/image-editing/demo/image-editing`,
			},
		},

		KNOWLEDGE: {
			path: "knowledge",
			fullPath: `${this.CONSOLE.path}/image-editing/knowledge`,
		},
	};

	public static readonly ADS_GENERATION = {
		path: "ads-generation",
		fullPath: `${this.CONSOLE.path}/ads-generation`,

		OVERVIEW: {
			path: "overview",
			fullPath: `${this.CONSOLE.path}/ads-generation/overview`,
		},

		API: {
			path: "api",
			fullPath: `${this.CONSOLE.path}/ads-generation/api`,
		},

		BRANDS_TEMPLATES: {
			path: "brands-template",
			fullPath: `${this.CONSOLE.path}/ads-generation/brands-template`,
		},

		IFRAME: {
			path: "iframe",
			fullPath: `${this.CONSOLE.path}/ads-generation/iframe`,
		},

		DEMO: {
			path: "demo",
			fullPath: `${this.CONSOLE.path}/ads-generation/demo`,
			ADS_GENERATION: {
				path: "ads-generation",
				fullPath: `${this.CONSOLE.path}/ads-generation/demo/ads-generation`,
			},
			ADS_EDITOR: {
				path: "ads-editor",
				fullPath: `${this.CONSOLE.path}/ads-generation/demo/ads-editor`,
			},
		},
	};

	public static readonly PRODUCT_SHOT = {
		path: "product-shot",
		fullPath: `${this.CONSOLE.path}/product-shot`,

		OVERVIEW: {
			path: "overview",
			fullPath: `${this.CONSOLE.path}/product-shot/overview`,
		},

		API: {
			path: "api",
			fullPath: `${this.CONSOLE.path}/product-shot/api`,
		},

		COMFY_UI: {
			path: "comfy-ui",
			fullPath: `${this.CONSOLE.path}/product-shot/comfy-ui`,
		},

		DEMO: {
			path: "demo",
			fullPath: `${this.CONSOLE.path}/product-shot/demo`,
			PRODUCT_SHOT: {
				path: "product-shot",
				fullPath: `${this.CONSOLE.path}/product-shot/demo/product-shot`,
			},
		},
	};

	public static readonly VIDEO_EDITING = {
		path: "video-editing",
		fullPath: `${this.CONSOLE.path}/video-editing`,

		OVERVIEW: {
			path: "overview",
			fullPath: `${this.CONSOLE.path}/video-editing/overview`,
		},
		API: {
			path: "api",
			fullPath: `${this.CONSOLE.path}/video-editing/api`,
		},
		DEMO: {
			path: "demo",
			fullPath: `${this.CONSOLE.path}/video-editing/demo`,
			VIDEO_GENERATION: {
				path: "video-generation",
				fullPath: `${this.CONSOLE.path}/video-editing/demo/video-generation`,
			},
		},
	};

	public static readonly IMAGE_SEARCH = {
		path: "image-search",
		fullPath: `${this.CONSOLE.path}/image-search`,

		OVERVIEW: {
			path: "overview",
			fullPath: `${this.CONSOLE.path}/image-search/overview`,
		},

		API: {
			path: "api",
			fullPath: `${this.CONSOLE.path}/image-search/api`,
		},

		DEMO: {
			path: "demo",
			fullPath: `${this.CONSOLE.path}/image-search/demo`,
			IMAGE_SEARCH: {
				path: "image-search",
				fullPath: `${this.CONSOLE.path}/image-search/demo/image-search`,
			},
		},
	};

	public static readonly ACCOUNT = {
		path: "account",
		fullPath: `${this.CONSOLE.path}/account`,
		requiresOrg: true,
	};

	public static readonly FORGOT_PASSWORD = {
		path: "/forgot-password",
	};

	public static readonly SIGNUP = {
		path: "/register",
	};

	public static readonly LOGIN = {
		path: "/login",
	};
	public static readonly PLUGIN_LOGIN = {
		path: "/plugin-login",
	};
	public static readonly MCP_AUTH = {
		path: "/mcp-auth",
	};
	public static readonly PLUGIN_LOGIN_STATUS = {
		path: "/pluginAuth-status",
	};
	public static readonly USER_INFO = {
		path: "/user-info",
	};

	public static readonly AUTH = {
		path: "/auth",
	};

	public static readonly PASSWORD_RESET = {
		path: "/password-reset",
	};
	public static readonly ACCOUNT_VERIFICATION = {
		path: "/account-verification",
	};

	public static readonly MODELS = {
		path: "models",
		fullPath: `${this.CONSOLE.path}/models`,
		requiresOrg: true,

		OVERVIEW: {
			path: "overview",
			fullPath: `${this.CONSOLE.path}/models/overview`,
		},
		FOUNDATION: {
			path: "foundation",
			fullPath: `${this.CONSOLE.path}/models/foundation`,
		},
		AUXILIARY: {
			path: "auxiliary",
			fullPath: `${this.CONSOLE.path}/models/auxiliary`,
		},
		ACCESS: {
			path: "access",
			fullPath: `${this.CONSOLE.path}/models/access`,
		},
		KNOWLEDGE: {
			path: "knowledge",
			fullPath: `${this.CONSOLE.path}/models/knowledge`,
		},
	};

	public static readonly IFRAME = {
		path: "iframe",
		fullPath: `${this.CONSOLE.path}/iframe`,
		requiresOrg: true,
	};
	public static readonly NEW_IFRAMES = {
		path: "iframes-v2",
		fullPath: `${this.CONSOLE.path}/iframes-v2`,
		requiresOrg: true,
	};

	public static readonly NEW_TG = {
		path: "tailored-generation",
		fullPath: `${this.CONSOLE.path}/tailored-generation`,
		requiresOrg: true,

		OVERVIEW: {
			path: "overview",
			fullPath: `${this.CONSOLE.path}/tailored-generation/overview`,
		},

		PROJECTS: {
			path: "projects",
			fullPath: `${this.CONSOLE.path}/tailored-generation/projects`,
			viewPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId`,
			editPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/edit`,
			createPath: `${this.CONSOLE.path}/tailored-generation/projects/create`,
			requiresOrg: true,
		},

		API: {
			path: "api",
			fullPath: `${this.CONSOLE.path}/tailored-generation/api`,
		},

		IFRAME: {
			path: "iframe",
			fullPath: `${this.CONSOLE.path}/tailored-generation/iframe`,
		},

		ACCESS_METHODS: {
			path: "access-methods",
			fullPath: `${this.CONSOLE.path}/tailored-generation/access-methods`,
		},

		DEMO: {
			path: "demo",
			fullPath: `${this.CONSOLE.path}/tailored-generation/demo`,

			IMAGE_GENERATION: {
				path: "image-generation",
				fullPath: `${this.CONSOLE.path}/tailored-generation/demo/image-generation`,
			},
			IMAGE_EDITING: {
				path: "image-editing",
				fullPath: `${this.CONSOLE.path}/tailored-generation/demo/image-editing`,
			},
		},

		BEST_PRACTICES: {
			path: "best-practices",
			fullPath: `${this.CONSOLE.path}/tailored-generation/best-practices`,
		},

		MODELS: {
			path: "models",
			fullPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/models`,
			viewPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/models/:modelId`,
			createPath: "models/create",
			createFullPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/models/create`,
			requiresOrg: true,

			PLAYGROUND: {
				path: "playground",
				fullPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/models/:modelId/playground`,
				requiresOrg: true,
			},

			DATASET: {
				path: "dataset",
				fullPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/models/:modelId/dataset/:datasetId`,
				requiresOrg: true,
			},
		},

		DATASETS: {
			path: "datasets",
			fullPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/datasets`,
			viewPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/datasets/:datasetId`,
			editPath: `${this.CONSOLE.path}/tailored-generation/projects/:projectId/datasets/:datasetId/edit`,
			requiresOrg: true,
		},
	};

	public static readonly CREATE_ORGANIZATION = {
		path: "/create-organization",
	};
	public static readonly SELECT_ORGANIZATION = {
		path: "/select-organization",
	};
	public static readonly NEW_IFRAMES_CONFIG = {
		path: "config",
		fullPath: `${this.NEW_IFRAMES.fullPath}/config`,
		requiresOrg: true,
	};
	public static readonly IFRAME_CONFIG = {
		path: "config",
		fullPath: `${this.IFRAME.fullPath}/config`,
		requiresOrg: true,
	};
	public static readonly IFRAME_EDITOR = {
		path: "iframe-editor",
		fullPath: `${this.CONSOLE.path}/iframe-editor`,
		requiresOrg: true,
	};
	public static readonly AUTH_KEYS = {
		path: "api-keys",
		fullPath: `${this.ACCOUNT.fullPath}/api-keys`,
		requiresOrg: true,
	};
	public static readonly USAGE_BILLING = {
		path: "usage",
		fullPath: `${this.ACCOUNT.fullPath}/usage`,
		requiresOrg: true,
	};
	public static readonly CAMPAIGN = {
		path: "campaign",
		fullPath: `${this.CONSOLE.path}/campaign`,
		requiresOrg: true,
	};
	public static readonly TEMPLATES = {
		path: "templates",
		fullPath: `${this.CAMPAIGN.fullPath}/templates`,
		requiresOrg: true,
	};
	public static readonly TEMPLATE_EDITOR = {
		path: `campaign/templates`,
		fullPath: `${this.TEMPLATES.fullPath}/:id`,
		editPath: `${this.TEMPLATES.fullPath}`,
		requiresOrg: true,
		private: true,
	};
	public static readonly NEW_TEMPLATE_EDITOR = {
		path: `campaign/templates/new`,
		fullPath: `${this.TEMPLATES.fullPath}/new`,
		requiresOrg: true,
	};
	public static readonly LAYOUT_EDITOR = {
		path: "campaign/layouts",
		fullPath: `${this.CAMPAIGN.fullPath}/layouts/:id`,
		editPath: `${this.CAMPAIGN.fullPath}/layouts`,
		requiresOrg: true,
		private: true,
	};
	public static readonly NEW_LAYOUT_EDITOR = {
		path: "campaign/layouts/new",
		fullPath: `${this.CAMPAIGN.fullPath}/layouts/new`,
		requiresOrg: true,
	};
	public static readonly BRANDS = {
		path: "brands",
		fullPath: `${this.CAMPAIGN.fullPath}/brands`,
		requiresOrg: true,
	};
	public static readonly BRAND_EDITOR = {
		path: `campaign/brands`,
		fullPath: `${this.BRANDS.fullPath}/:id`,
		editPath: `${this.BRANDS.fullPath}`,
		requiresOrg: true,
		private: true,
	};

	public static readonly NEW_BRAND_EDITOR = {
		path: `campaign/brands/new`,
		fullPath: `${this.BRANDS.fullPath}/new`,
		requiresOrg: true,
	};
	public static readonly FONTS = {
		path: "fonts",
		fullPath: `${this.CAMPAIGN.fullPath}/fonts`,
		requiresOrg: true,
	};
	public static readonly USERS = {
		path: "users",
		fullPath: `${this.ACCOUNT.fullPath}/users`,
		requiresOrg: true,
	};
	public static readonly RELATED_ORGANIZATIONS = {
		path: "related-organizations",
		fullPath: `${this.ACCOUNT.fullPath}/related-organizations`,
		requiresOrg: true,
	};
	public static readonly SUBSCRIPTION = {
		path: "subscription",
		fullPath: `${this.ACCOUNT.fullPath}/subscription`,
		requiresOrg: true,
	};
	public static readonly ACCOUNT_IFRAMES = {
		path: "iframes",
		fullPath: `${this.ACCOUNT.fullPath}/iframes`,
		requiresOrg: true,
	};
	public static readonly NEW_IFRAMES_EDITOR = {
		path: `iframes`,
		fullPath: `${this.ACCOUNT_IFRAMES.fullPath}/:id`,
		editPath: `${this.ACCOUNT_IFRAMES.fullPath}`,
		createPath: `${this.ACCOUNT_IFRAMES.fullPath}/new`,
		requiresOrg: true,
		private: true,
	};
	public static readonly AttributionReports = {
		path: "attribution-reports",
		fullPath: `${this.ACCOUNT.fullPath}/attribution-reports`,
		requiresOrg: true,
	};
	public static readonly GENERATION_REPORT = {
		path: "generation-report",
		fullPath: `${this.AttributionReports.fullPath}/generation-report`,
		requiresOrg: true,
	};
	public static readonly CATALOG_REPORT = {
		path: "catalog-report",
		fullPath: `${this.AttributionReports.fullPath}/catalog-report`,
		requiresOrg: true,
	};
	public static readonly TOP_IMAGES = {
		path: "top-images",
		fullPath: `${this.AttributionReports.fullPath}/top-images`,
		requiresOrg: true,
	};
	public static readonly PARTNERS_EARNINGS = {
		path: "partners-earnings",
		fullPath: `${this.AttributionReports.fullPath}/partners-earnings`,
		requiresOrg: true,
	};
	public static readonly PAGE_NOT_FOUND = {
		path: "page-not-found",
		fullPath: "page-not-found",
	};
	public static readonly MOBILE_NOT_SUPPORTED_PAGE = {
		path: "mobile-not-supported",
		fullPath: "mobile-not-supported",
	};
	public static readonly USER_PROFILE = {
		path: "user-profile",
		fullPath: `${this.CONSOLE.path}/user-profile`,
	};
	public static readonly PROFILE = {
		path: "profile",
		fullPath: `${this.USER_PROFILE.fullPath}/profile`,
	};
	public static readonly APPS = {
		path: "playground-hub",
		fullPath: `/playground-hub`,

		TG: {
			path: "tailored-generation",
			fullPath: "/playground-hub/tailored-generation",

			IMAGE: {
				path: "image",
				fullPath: "/playground-hub/tailored-generation/image",
			},
			VIDEO: {
				path: "video",
				fullPath: "/playground-hub/tailored-generation/video",
			},
		},
	};
	public static readonly OLD_APPS = {
		path: "apps",
		fullPath: `/apps`,
	};
	public static readonly FOX_APPS = {
		path: "fox-apps",
	};
	public static readonly TEXT_TO_IMAGE = {
		path: "image-generation",
		fullPath: `/${this.APPS.path}/image-generation`,
	};
	public static readonly TEXT_TO_VECTOR = {
		path: "text-to-vector",
		fullPath: `/${this.APPS.path}/text-to-vector`,
	};
	public static readonly IMAGE_TO_IMAGE = {
		path: "image-editing",
		fullPath: `/${this.APPS.path}/image-editing`,
	};
	public static readonly AI_EDITOR = {
		path: "ai-editor",
	};
	public static readonly PRODUCT_PLACEMENT = {
		path: "product-placement/generator",
		fullPath: `${this.APPS.path}/product-placement/generator`,
	};
	public static readonly PRODUCT_PLACEMENT_GALLERY = {
		path: "product-placement",
		fullPath: `${this.APPS.path}/product-placement`,
	};
	public static readonly DESIGN_EDITOR = {
		path: "campaign-editor",
		fullPath: `/${this.APPS.path}/campaign-editor`,
		editPath: `/${this.APPS.path}/campaign-editor`,
		templatesPath: `/${this.APPS.path}/campaign-editor/templates`,
		campaignsPath: `/${this.APPS.path}/campaign-editor/campaigns`,
	};
	public static readonly AUTOMOTIVE = {
		path: "/automotive",
	};

	public static readonly AUTOMOTIVE_EDITOR = {
		path: "/editor",
		fullPath: `${this.AUTOMOTIVE.path}/editor`,
	};

	public static readonly NEW_AUTOMOTIVE_PROJECT = {
		path: "/create",
		fullPath: `${this.AUTOMOTIVE.path}/create`,
	};
	public static readonly AUTOMOTIVE_PROJECTS = {
		path: "/projects",
		fullPath: `${this.AUTOMOTIVE.path}/projects`,
	};
	public static readonly AUTOMOTIVE_PROJECT = {
		path: `${this.AUTOMOTIVE.path}/projects`,
		fullPath: `${this.AUTOMOTIVE.path}/projects/:project_id`,
	};
	public static readonly AUTOMOTIVE_PROJECT_UPLOADED = {
		path: `/uploaded`,
		fullPath: `${this.AUTOMOTIVE.path}/projects/:project_id/uploaded`,
	};

	public static readonly AUTOMOTIVE_PROJECT_FAVORITES = {
		path: `/favorites`,
		fullPath: `${this.AUTOMOTIVE.path}/projects/:project_id/favorites`,
	};

	public static readonly AUTOMOTIVE_PROJECT_SESSION = {
		path: "/session",
		fullPath: `${this.AUTOMOTIVE_PROJECT.fullPath}/session/:session_id`,
	};
	public static readonly AUTOMOTIVE_PROJECT_SIMPLE_SESSION = {
		path: "/simple-session",
		fullPath: `${this.AUTOMOTIVE.path}/simple-session/`,
	};
}
